import React from 'react';
import { Link } from 'react-router-dom';
import './AppFooter.scss';

const AppFooter: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        <p className="app-footer__legal">
          <strong>PoC Platform</strong>
          {' — an internal ISS tool, 2026 © ISS World.'}
        </p>
        <Link to="/guidebook" className="app-footer__link">
          PoC Guidelines
        </Link>
      </div>
    </footer>
  );
};

export default AppFooter;
